import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { FilterModelItemEntity } from '../../domain/filter-model-item.entity';
import { FilterModelListEntity } from '../../domain/filter-model-list.entity';

@Injectable()
export class FilterModelListProvider {
	private readonly filterModelList: FilterModelListEntity;

	public constructor() {
		this.filterModelList = FilterModelListEntity.build([
			{
				field: 'label',
				alias: $localize`:i18n=@@subscription.filterModel.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 0,
			},
			{
				field: 'description',
				alias: $localize`:i18n=@@subscription.filterModel.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 1,
			},
			{
				field: 'root',
				alias: $localize`:i18n=@@subscription.filterModel.list.column.query-view:`,
				type: 'string',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: false,
				visibleIndex: 2,
			},
			{
				field: 'linkedProfileIds',
				alias: $localize`:i18n=@@subscription.filterModel.list.column.profiles:`,
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 3,
			},
		]);
	}

	public getList(): FilterModelListEntity {
		return this.filterModelList;
	}

	public setListElements(
		elements: Map<string, FilterModelItemEntity>
	): FilterModelListEntity {
		return this.filterModelList.setElements(elements);
	}
}
